<template>
    <div id="non-fiction-audio-player">
        <span />
    </div>
</template>

<script>
/**
 * https://github.com/sirg2003/vue-howler
 * VueHoler is a mixin
 */
import VueHowler from "vue-howler";
import { mapState, mapGetters } from "vuex";
import playerEventsMixins from "./playerEventsMixins";
import freemiumAccessMixins from "@/mixins/freemiumAccessMixins";

export default {
    name: "NonFictionPlayer",
    mixins: [VueHowler, playerEventsMixins, freemiumAccessMixins],
    props: {
        html5: {
            type: Boolean,
            default: true
        },
        preload: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            oldValidProgress: 0
        }
    },
    computed: {
        ...mapState({
            currentAudioProgress: state => state.NonfictionPlayer.currentAudioProgress,
            currentRate: state => state.NonfictionPlayer.rate,
            executeFoward: state => state.NonfictionPlayer.forward,
            executeRewind: state => state.NonfictionPlayer.rewind,
            isPlaying: state => state.NonfictionPlayer.isPlaying,
            bookInsight: state => state.NonfictionPlayer.bookInsight
        }),
        ...mapGetters({
            currentAudioSource: "NonfictionPlayer/currentAudioSource"
        })
    },
    watch: {
        duration() {
            this.$store.dispatch("NonfictionPlayer/setSelectedAudioSourceDuration", Number(this.duration));
        },
        isPlaying(current) {
            if (current) {
                this.$store.dispatch("NonfictionPlayer/setSelectedAudioSourceDuration", Number(this.duration));
                this.play();
            } else {
                this.pause();
            }
        },
        progress(current) {
            const progressPercent = Math.ceil(current * 100);
            if ((progressPercent > 0)) {
                this.oldValidProgress = progressPercent;
                this.updateSelectedAudioSourceProgress(progressPercent);
            }

            if (progressPercent > 50 && this.$_freemiumBiLocked()) {
                this.$store.dispatch("NonfictionPlayer/resetSelectedAudioState", 0);
                this.setPlayerSeek(0);
                this.$_scrollToSignUpWall({ behavior: "smooth", block: "nearest" });
            }
        },
        currentAudioProgress(current) {
            this.setPlayerProgress(current);
        },
        currentRate(current) {
            this.changeRate(current);
        },
        executeRewind(current) {
            this.rewind(current);
        },
        executeFoward(current) {
            this.forward(current);
        }
    },
    methods: {
        playAndPause() {
            this.$store.dispatch("NonfictionPlayer/toggle");
        },
        forward() {
            let newSeek = Number(this.seek + 30);
            if (this.duration < newSeek) {
                newSeek = this.duration;
            }
            this.setPlayerSeek(newSeek);
            this.$_dispatchPlayerActionEvent("forward", {
                themeTitle: this.currentAudioSource.title
            });
        },
        rewind() {
            let newSeek = Number(this.seek - 30);
            if (0 > newSeek) {
                newSeek = 0;
            }
            this.setPlayerSeek(newSeek);

            this.$_dispatchPlayerActionEvent("rewind", {
                themeTitle: this.currentAudioSource.title
            })
        },
        updateSelectedAudioSourceProgress(progres = 0) {
            this.$store.dispatch("NonfictionPlayer/setSelectedAudioSourceProgress", Number(progres));
        },
        setPlayerProgress(value) {
            // mixin method
            this.setProgress(value);
        },
        setPlayerSeek(value) {
            // mixin method
            this.setSeek(value);
        },
        changeRate(rate) {
            // mixin method
            this.setRate(Number(rate));
        }
    }
}
</script>
